// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__uqgpn","alert":"SettungsInbox_alert__2qXfn"};